import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1365.333",
  height: "1365.333",
  version: "1.0",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m267.8 82.7-8.7.4-56.2 95.2c-74.5 126.1-107 181.2-156.1 265-37 63.1-40.7 69.9-39.7 72 3.8 7.1 115.4 196.9 201.3 342.3l50.9 86.1 73.5.6c94.5.9 293.9.9 374 0l62.3-.6 17.3-29.1c9.5-16 25.2-42.4 34.8-58.6 17.2-29 190.5-323.2 198-336.2l3.9-6.6-43.2-73.4c-23.8-40.3-67.7-114.9-97.7-165.8-29.9-50.9-67.8-114.9-84-142.3L768.6 82l-246.1.2c-135.3.1-249.9.4-254.7.5" }, null, -1)
  ]))]))
}
export default { render: render }